/**
 * One id per distinguishable state, shared by the status badge AND the
 * "Next step" filter (`editorial-next-step.ts`) — see the 2026-09-21 incident this fixes: the
 * filter's five options were built against `topic.status` alone while the
 * table's badge (via `score`/`publication`) could show six OTHER labels no
 * option matched, so "Ready to hand off" — the label on every real row that
 * day — had no filter that selected it.
 */
export const EDITORIAL_WORKFLOW_STATUS_IDS = [
  'proposed',
  'needs-review',
  'approved',
  'in-progress',
  'editorial-review',
  'run-failed',
  'written',
  'ready',
  'review-limited',
  'claims-pending',
  'handed-off',
  'seo-review',
  'images',
  'scheduled',
  'published',
] as const;

export type EditorialWorkflowStatusId = (typeof EDITORIAL_WORKFLOW_STATUS_IDS)[number];
